@if ((authenticated$ | async) && (routeDataIsAvailable$ | async)) {
  @if (showSystemMainNavigation) {
    <portal-system-admin-main-nav></portal-system-admin-main-nav>
    <portal-system-sub-nav />
  }
  <!-- Service-Provider -->
  @if (showServiceProviderMainNavigation) {
    <portal-service-provider-main-nav></portal-service-provider-main-nav>
  }
  <!-- Enterprise -->
  @if (showEnterpriseAdminMainNavigation) {
    <portal-enterprise-main-nav></portal-enterprise-main-nav>
    <portal-enterprise-sub-nav></portal-enterprise-sub-nav>
  }
  <!-- End-User -->
  @if (isEndUser) {
    <portal-end-user-main-nav></portal-end-user-main-nav>
    <portal-end-user-sub-nav></portal-end-user-sub-nav>
  }
}
